import React from 'react';
import withRouter from 'src/config/withRouter';
import {connect} from 'react-redux';
import { withTranslation } from 'react-i18next';
import { change_lang, update_cart, setCompanyId } from '../../../store/action';
// material ui
import {  Popper, Paper, Grow, ClickAwayListener,MenuItem, MenuList, Snackbar, Badge } from '@mui/material';
import { ExpandMoreOutlined, ShoppingCartOutlined } from '@mui/icons-material'
import makeStyles from '@mui/styles/makeStyles';
import withStyles from '@mui/styles/withStyles';
import  { TermDialog, CheckoutDialog } from '../../parent-booking';

const StyledBadge = withStyles((theme) => ({
    badge: {
        right: -3,
        top: 13,
        border: `2px solid ${theme.palette.background.paper}`,
        padding: '0 4px',
    },
}))(Badge);

const useStyles = makeStyles(theme => ({
    header:{
        width:'100%',
        display:'flex',
        flexDirection:'column',
        height:'46px',
        backgroundColor:'#0F467A',
    },

    leftSide:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        justifyContent:'space-between',
        alignSelf:'flex-end',
        margin:'auto 0px',
        width:'440px',
        [theme.breakpoints.between('xs','md')]: {
            width:'75%'
        }
    },

    refDiv:{
        display:'flex',
        flexDirection:'row',
        alignItems:'center',
        width:'calc(100% / 3)',
        cursor:'pointer'
    },

    text:{
        color:'#FFF',
        fontSize:'18px',
        textTransform:'uppercase',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'12px'
        }
    },

    buttons:{
        color:'#FFF',
        fontSize:'18px',
        textTransform:'capitalize',
        outline:'none',
        border:'none',
        backgroundColor:'transparent',
        width:'calc(100% / 3)',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'12px'
        }
    },

    cartTxt:{
        [theme.breakpoints.between('xs','md')]: {
            display:'none'
        }
    },

    borderRight:{
        borderRight:'1px solid #fff'
    },
    borderLeft:{
        borderLeft:'1px solid #fff'
    },

    expandIcon:{
        color:'#fff',
        [theme.breakpoints.between('xs','md')]: {
            fontSize:'1.2rem'
        }
    },

    badgeBtnTxt:{
        fontSize:'13px',
    },

    marLeft:{
        marginLeft:'25px'
    },

    marRight:{
        marginRight:'25px'
    }
}));

function Header(props) {
    let { lang, cartList, setCart, companyId, companyName, user, company, set_companyId, t, i18n, history } = props;
    const languageRef = React.useRef(null);
    const [open, setSnack] = React.useState(false);
    const [message, setMessage] = React.useState('');
    const [languageOpen, setLangOpen] = React.useState(false);
    const [termArray, setTermArray] = React.useState([]);
    const [checkoutDialog, setcheckoutDialog] = React.useState(false);
    const [termDialog, setTermDialog] = React.useState(false);
    const [language,setLang] = React.useState(lang);
    const urlName = company?.urlName || '';
    
    const handleToggle = () => { // open/close language menu
        setLangOpen(!languageOpen)
    };
    const handleClose = () => { // close lang menu
        setLangOpen(false);
    }
    const handleListKeyDown = (event) => { // open/close on key click
        if (event.key === 'Tab') {
            event.preventDefault();
            setLangOpen(!languageOpen);
        }
    }
    const update_lang = e => { // update lang according to user select
        let { change_lang, i18n } = props;
        change_lang(e);
        i18n.changeLanguage(e);
        setLangOpen(!languageOpen);
        setLang(e)
    }

    const snackClose = () => setSnack(false);

    // checkout dialog events,,,,
    const checkDialogClose = () => setcheckoutDialog(!checkoutDialog);

    const checkTermCondition = async () => {
        const isTermExists = cartList.filter(v => v.termText);
        const extractArray = isTermExists.map(v => ({serviceName: v.serviceName,termText: v.termText}));
        var unique = extractArray.filter((thing, index) => {
            const _thing = JSON.stringify(thing);
            return index === extractArray.findIndex(obj => {
              return JSON.stringify(obj) === _thing;
            });
          });
        if(unique.length > 0) {
            setTermDialog(true);
            setTermArray(unique);
        }
        else{
            redirectCheckout()
        }
    }

    const removeReservation = index => {
        let cartCopy = cartList.slice();
        cartCopy.splice(index,1);
        setCart(cartCopy);
        setMessage(t('booking.removeCheckout'));
        setSnack(true);
    }

    // term Dialog events
    const onchangeTerm = agree => agree ? redirectCheckout() : termDialogClose();

    const termDialogClose = () => setTermDialog(!termDialog);

    const redirectCheckout = () => history.push(`/booking/${companyId}/directCheckout`);

    const redirectRenew = () => {
        const isParent = user && user.isParent;
        const companyId = company && company.id;
        if(isParent && companyId) {
            set_companyId(companyId);
            history.push(`/dashboard`);
        }
        else{
            const hostname = ['my.selynk.com','localhost:3002']?.includes(window?.location?.host);
            history.push(hostname ? `/login/${urlName ? urlName : companyId}` : `/login`);
        }
    };

    const classes = useStyles();
    const isRTL = i18n.translator.language;
    const ar = "'Cairo', sans-serif";
    const en = "'Poppins', sans-serif";
    const fontFamily = isRTL === 'ar' ? ar : en;
    return(
        <>
        <div className={classes.header} dir={isRTL === 'ar' ? 'rtl' : 'ltr'}>
            <div className={classes.leftSide}>
                {/* select lang */}
                <div className={`${classes.refDiv} ${isRTL === 'ar' ? classes.borderLeft : classes.borderRight}`}
                        ref={languageRef}
                        aria-controls={languageOpen ? 'menu-list-grow' : undefined}
                        aria-haspopup="true"
                        onClick={handleToggle}
                        >
                        <span className={classes.text} style={{fontFamily}}>{language === 'en' ? t('setting-comp.en') : t('setting-comp.ar')}</span>
                        <ExpandMoreOutlined className={classes.expandIcon}/>

                        <Popper open={languageOpen} anchorEl={languageRef.current} style={{zIndex:500}} role={undefined} transition disablePortal>
                        {({ TransitionProps, placement }) => (
                            <Grow
                            {...TransitionProps}
                            style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
                            >
                            <Paper>
                                <ClickAwayListener onClickAway={handleClose}>
                                <MenuList autoFocusItem={languageOpen} id="menu-list-grow" onKeyDown={handleListKeyDown}>
                                    <MenuItem style={language === 'en' ? {fontFamily,backgroundColor: '#0F467A',color:'#fff'} : {fontFamily,backgroundColor:'transparent'}} onClick={()=> update_lang('en')} value="en">{t('setting-comp.en')}</MenuItem>
                                    <MenuItem style={language === 'ar' ? {fontFamily,backgroundColor: '#0F467A',color:'#fff'} : {fontFamily,backgroundColor:'transparent'}} onClick={()=> update_lang('ar')} value="ar">{t('setting-comp.ar')}</MenuItem>
                                </MenuList>
                                </ClickAwayListener>
                            </Paper>
                            </Grow>
                        )}
                        </Popper>
                    </div>
                {/* login btn */}
                <button type="button" style={{fontFamily}} onClick={redirectRenew} className={`${classes.buttons} ${isRTL === 'ar' ? classes.borderLeft : classes.borderRight}`}>{t('booking.steps.login')}</button>
                {/* view cart btn */}
                <button type="button" style={{fontFamily}} onClick={cartList.length ? checkDialogClose : null} className={`${classes.buttons} ${classes.badgeBtnTxt}`}>
                    <StyledBadge badgeContent={cartList.length} color="secondary" classes={{root:`${isRTL === 'ar' ? classes.marLeft : classes.marRight}`}}>
                        <ShoppingCartOutlined />
                    </StyledBadge>
                    <span className={classes.cartTxt}>{t('accept-dialog.cart-view')}</span>
                </button>
            </div>
        </div>
        <CheckoutDialog 
            {...{open:checkoutDialog,checkoutReservation:cartList,onClose:checkDialogClose,checkTermCondition:checkTermCondition,removeReservation:removeReservation}}
        />

        <TermDialog 
            {...{open:termDialog,termArray,companyName,onChange:onchangeTerm,onClose:termDialogClose}}
        />

        <Snackbar
            anchorOrigin={{ vertical:'bottom', horizontal:'center' }}
            key='bottom center'
            open={open}
            autoHideDuration={3000}
            onClose={snackClose}
            ContentProps={{
            'aria-describedby': 'message-id',
            }}
            message={<span id="message-id" style={{fontFamily}}>{message}</span>}
        />
        </>
    )
}

const mapDispatchToProps = dispatch => {
    return {
        change_lang : lang => dispatch(change_lang(lang)),
        setCart : updatedArray => dispatch(update_cart(updatedArray)), // update reservation cart
        set_companyId : id => dispatch(setCompanyId(id)),
    }
}

const mapStateToProps = state => {
    return{
        lang: state.lang,
        user: state.user,
        cartList: state.cartList,
        company_id: state.company_id,
        company: state.company
    }
}

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(withTranslation('common')(Header)));